import {AbstractStorage} from "../../services/storage/abstract-storage";
import {LocalStorageService} from "../../services/storage/local-storage";


const lastBootCampCourseIdStorageKey = `lastBootCampCourseId`;

export class BootcampLastCourseIdRepository {
  constructor(private storage: AbstractStorage = new LocalStorageService()) {
  }

  public set(value: number): void {
    this.storage.setItem<string>(lastBootCampCourseIdStorageKey, `${value}`);
  }

  public get(): string | undefined {
    return this.storage.getItem<string>(lastBootCampCourseIdStorageKey);
  }

  public delete(): void {
    this.storage.removeItem(lastBootCampCourseIdStorageKey);
  }

}

export const bootcampLastCourseIdRepository = new BootcampLastCourseIdRepository();
